"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MountUtils = exports.FragmentsPlugin = exports.FragmentsLoaderProvider = void 0;
var fragments_loader_provider_1 = require("./fragments-loader-provider");
Object.defineProperty(exports, "FragmentsLoaderProvider", { enumerable: true, get: function () { return fragments_loader_provider_1.FragmentsLoaderProvider; } });
var fragments_plugin_1 = require("./plugins/fragments.plugin");
Object.defineProperty(exports, "FragmentsPlugin", { enumerable: true, get: function () { return fragments_plugin_1.FragmentsPlugin; } });
var mount_1 = require("./utils/mount");
Object.defineProperty(exports, "MountUtils", { enumerable: true, get: function () { return mount_1.MountUtils; } });
__exportStar(require("./types"), exports);
